export const MODE_STEAM = "steam";
export const MODE_ELECTRICITY = "electricity";

export const billBucketMethodOptions = [
  {
    value: 0,
    label: "Leading",
  },
  {
    value: 1,
    label: "Lagging",
  },
];

export const billDateOptions = [...Array(30).keys()].map((index) => ({
  value: index + 1,
  label: `${index + 1}`,
}));

export const NO_ACCOUNTS_MESSAGE =
  "There are no accounts configured for this building.";

export const NOT_ENOUGH_DATA_AVAILABLE_MESSAGE =
  "There is not enough data available for this account.";
